export enum GanttViewType {
    day = 'day',
    quarter = 'quarter',
    month = 'month',
    year = 'year',
    week = 'week',
    hour = 'hour'
}
